<template>
  <textarea v-bind="$attrs" :value="displayValue" class="form-control" @input="onInput" @change="$emit('change', displayValue)"></textarea>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue'
export default defineComponent({
  name: 'BFormTextarea',
  inheritAttrs: false,
  props: { modelValue: { default: undefined }, value: { default: undefined } },
  emits: ['update:modelValue', 'input', 'change'],
  setup(props, { emit }) {
    const displayValue = computed(() => props.modelValue ?? props.value ?? '')
    const onInput = (event: Event) => {
      const value = (event.target as HTMLTextAreaElement).value
      emit('update:modelValue', value)
      emit('input', value)
    }
    return { displayValue, onInput }
  }
})
</script>
